import { db } from '../utils/db';
import { useDb } from './useDb';

/** Anna's memory as stored in the shared db. Every change is logged there too. */
export function useMemoryStore() {
  const memory = useDb((t) => t.memory);
  return {
    ...memory,
    accept: db.acceptMemory,
    reject: db.rejectMemory,
    forgetKnowledge: (id: string) => db.forgetMemory('knowledge', id),
    forgetWorkflow: (id: string) => db.forgetMemory('workflows', id),
    forgetEvent: (id: string) => db.forgetMemory('events', id),
  };
}
